import { Injectable } from '@angular/core';
import { Config } from '@capacitor-community/safe-area';
import { from, Observable } from 'rxjs';
import { SafeAreaWrapper } from 'src/app/wrappers/safe-area.wrapper';
import { SafeAreaBarStyle, SafeAreaConfig } from './safe-area.config';

@Injectable({
  providedIn: 'root'
})
export class SafeAreaAdapter {

  constructor(
    private safeAreaWrapper: SafeAreaWrapper
  ) {}

  enable(config: SafeAreaConfig): Observable<void> {
    const capacitorConfig = this.mapSafeAreaConfigToCapacitorSafeAreaConfig(config);
    const enablePromise = this.safeAreaWrapper.enable(capacitorConfig);
    const enableObs = from(enablePromise);

    return enableObs;
  }

  private mapSafeAreaConfigToCapacitorSafeAreaConfig(config: SafeAreaConfig): Config {
    const capacitorBarStyle = this.mapSafeAreaBarStyleToCapacitorBarStyle(config.barStyle);
    const capacitorConfig: Config = {
      customColorsForSystemBars: true,
      statusBarColor: config.statusBarColor,
      navigationBarColor: config.navigationBarColor,
      statusBarContent: capacitorBarStyle,
      navigationBarContent: capacitorBarStyle,
    }

    return capacitorConfig;
  }

  private mapSafeAreaBarStyleToCapacitorBarStyle(style: string): 'light' | 'dark' {
    return style === SafeAreaBarStyle.Light ? 'light' : 'dark';
  }
}